import React, { useEffect } from 'react';
import { Fade } from 'react-bootstrap';
import { useRecoilValue } from 'recoil';
import '../../css/main.css';
import {
	languageSetting,
	translatedText,
} from '../../recoil-states/language-state';

const Roadmap = () => {
	const lang = useRecoilValue(languageSetting);

	const roadmapList = [
		{
			id: 1,
		},
		{
			id: 2,
		},
		{
			id: 3,
		},
		{
			id: 4,
		},
		{
			id: 5,
		},
		{
			id: 6,
		},
	];

	return (
		<div className='main_roadmap_box'>
			{roadmapList.map((item, index) => {
				return (
					<div
						key={item.id}
						className='main_roadmap_card'
						style={item.id % 2 === 0 ? { float: 'right' } : null}>
						{/* <Fade direction={item.id % 2 === 0 ? 'right' : 'left'} triggerOnce className="kct_Roadmap_revealBox"> */}
						<img
							src={require(`../../assets/roadmap_assets/roadmap_${lang}${item.id}.webp`)}
						/>
						{/* </Fade> */}
					</div>
				);
			})}
		</div>
	);
};

export default Roadmap;
